<div>
  <div *ngIf="this.language" class="flag-container" [ngClass]="{'center': this.center}">
    <img class="flag-img" [src]="getImageSource(this.language)">
    <div *ngIf="this.withLanguageText" class="language-text">
      <span>{{this.getLanguage(this.language)}}</span>
    </div>
  </div>

  <div *ngFor="let language of multipleLanguages" class="flag-container">
    <img class="flag-img" [src]="getImageSource(language)">
  </div>

</div>
